import { InnerBlocks } from '@wordpress/block-editor';

export default function save() {
  return <InnerBlocks.Content />;
}
